/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { FormulaCalculationResponse } from '../models';
// @ts-ignore
import type { GreenGrpAddressableTelevisionRequest } from '../models';
// @ts-ignore
import type { GreenGrpCinemaRequest } from '../models';
// @ts-ignore
import type { GreenGrpDoohGrossContactsRequest } from '../models';
// @ts-ignore
import type { GreenGrpDoohScreensRequest } from '../models';
// @ts-ignore
import type { GreenGrpLinearTelevisionRequest } from '../models';
// @ts-ignore
import type { GreenGrpNewspaperRequest } from '../models';
// @ts-ignore
import type { GreenGrpOOHRequest } from '../models';
// @ts-ignore
import type { GreenGrpOnlineAudioRequest } from '../models';
// @ts-ignore
import type { GreenGrpOnlineImageRequest } from '../models';
// @ts-ignore
import type { GreenGrpOnlineSearchRequest } from '../models';
// @ts-ignore
import type { GreenGrpOnlineVideoRequest } from '../models';
// @ts-ignore
import type { GreenGrpPrintTotalWeightRequest } from '../models';
// @ts-ignore
import type { GreenGrpRadioRequest } from '../models';
// @ts-ignore
import type { GreenGrpSocialMediaOnlineImageRequest } from '../models';
// @ts-ignore
import type { GreenGrpSocialMediaOnlineVideoRequest } from '../models';
// @ts-ignore
import type { GreenGrpSupplementRequest } from '../models';
/**
 * CalculationServiceGreenGRPApi - axios parameter creator
 */
export const CalculationServiceGreenGRPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpAddressableTelevisionRequest} greenGrpAddressableTelevisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpAddressableTelevision: async (greenGrpAddressableTelevisionRequest: GreenGrpAddressableTelevisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpAddressableTelevisionRequest' is not null or undefined
            assertParamExists('greenGrpAddressableTelevision', 'greenGrpAddressableTelevisionRequest', greenGrpAddressableTelevisionRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/addressable-television`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpAddressableTelevisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpCinemaRequest} greenGrpCinemaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpCinema: async (greenGrpCinemaRequest: GreenGrpCinemaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpCinemaRequest' is not null or undefined
            assertParamExists('greenGrpCinema', 'greenGrpCinemaRequest', greenGrpCinemaRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/cinema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpCinemaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate digital out of home CO2 emissions using gross contacts
         * @param {GreenGrpDoohGrossContactsRequest} greenGrpDoohGrossContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpDoohGrossContacts: async (greenGrpDoohGrossContactsRequest: GreenGrpDoohGrossContactsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpDoohGrossContactsRequest' is not null or undefined
            assertParamExists('greenGrpDoohGrossContacts', 'greenGrpDoohGrossContactsRequest', greenGrpDoohGrossContactsRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/dooh-gross-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpDoohGrossContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate digital out of home CO2 emissions using number of screens
         * @param {GreenGrpDoohScreensRequest} greenGrpDoohScreensRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpDoohScreens: async (greenGrpDoohScreensRequest: GreenGrpDoohScreensRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpDoohScreensRequest' is not null or undefined
            assertParamExists('greenGrpDoohScreens', 'greenGrpDoohScreensRequest', greenGrpDoohScreensRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/dooh-screens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpDoohScreensRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpLinearTelevisionRequest} greenGrpLinearTelevisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpLinearTelevision: async (greenGrpLinearTelevisionRequest: GreenGrpLinearTelevisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpLinearTelevisionRequest' is not null or undefined
            assertParamExists('greenGrpLinearTelevision', 'greenGrpLinearTelevisionRequest', greenGrpLinearTelevisionRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/linear-television`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpLinearTelevisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpNewspaperRequest} greenGrpNewspaperRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpNewspaper: async (greenGrpNewspaperRequest: GreenGrpNewspaperRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpNewspaperRequest' is not null or undefined
            assertParamExists('greenGrpNewspaper', 'greenGrpNewspaperRequest', greenGrpNewspaperRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/newspaper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpNewspaperRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate out of home CO2 emissions
         * @param {GreenGrpOOHRequest} greenGrpOOHRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOOH: async (greenGrpOOHRequest: GreenGrpOOHRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpOOHRequest' is not null or undefined
            assertParamExists('greenGrpOOH', 'greenGrpOOHRequest', greenGrpOOHRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/ooh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpOOHRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineAudioRequest} greenGrpOnlineAudioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineAudio: async (greenGrpOnlineAudioRequest: GreenGrpOnlineAudioRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpOnlineAudioRequest' is not null or undefined
            assertParamExists('greenGrpOnlineAudio', 'greenGrpOnlineAudioRequest', greenGrpOnlineAudioRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/online-audio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpOnlineAudioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineImageRequest} greenGrpOnlineImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineImage: async (greenGrpOnlineImageRequest: GreenGrpOnlineImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpOnlineImageRequest' is not null or undefined
            assertParamExists('greenGrpOnlineImage', 'greenGrpOnlineImageRequest', greenGrpOnlineImageRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/online-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpOnlineImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineSearchRequest} greenGrpOnlineSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineSearch: async (greenGrpOnlineSearchRequest: GreenGrpOnlineSearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpOnlineSearchRequest' is not null or undefined
            assertParamExists('greenGrpOnlineSearch', 'greenGrpOnlineSearchRequest', greenGrpOnlineSearchRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/online-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpOnlineSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineVideoRequest} greenGrpOnlineVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineVideo: async (greenGrpOnlineVideoRequest: GreenGrpOnlineVideoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpOnlineVideoRequest' is not null or undefined
            assertParamExists('greenGrpOnlineVideo', 'greenGrpOnlineVideoRequest', greenGrpOnlineVideoRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/online-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpOnlineVideoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpRadioRequest} greenGrpRadioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpRadio: async (greenGrpRadioRequest: GreenGrpRadioRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpRadioRequest' is not null or undefined
            assertParamExists('greenGrpRadio', 'greenGrpRadioRequest', greenGrpRadioRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/radio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpRadioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpSocialMediaOnlineImageRequest} greenGrpSocialMediaOnlineImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpSocialMediaOnlineImage: async (greenGrpSocialMediaOnlineImageRequest: GreenGrpSocialMediaOnlineImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpSocialMediaOnlineImageRequest' is not null or undefined
            assertParamExists('greenGrpSocialMediaOnlineImage', 'greenGrpSocialMediaOnlineImageRequest', greenGrpSocialMediaOnlineImageRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/social-media-online-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpSocialMediaOnlineImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpSocialMediaOnlineVideoRequest} greenGrpSocialMediaOnlineVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpSocialMediaOnlineVideo: async (greenGrpSocialMediaOnlineVideoRequest: GreenGrpSocialMediaOnlineVideoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpSocialMediaOnlineVideoRequest' is not null or undefined
            assertParamExists('greenGrpSocialMediaOnlineVideo', 'greenGrpSocialMediaOnlineVideoRequest', greenGrpSocialMediaOnlineVideoRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/social-media-online-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpSocialMediaOnlineVideoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpSupplementRequest} greenGrpSupplementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpSupplement: async (greenGrpSupplementRequest: GreenGrpSupplementRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpSupplementRequest' is not null or undefined
            assertParamExists('greenGrpSupplement', 'greenGrpSupplementRequest', greenGrpSupplementRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/supplement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpSupplementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpPrintTotalWeightRequest} greenGrpPrintTotalWeightRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpTotalWeight: async (greenGrpPrintTotalWeightRequest: GreenGrpPrintTotalWeightRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'greenGrpPrintTotalWeightRequest' is not null or undefined
            assertParamExists('greenGrpTotalWeight', 'greenGrpPrintTotalWeightRequest', greenGrpPrintTotalWeightRequest)
            const localVarPath = `/calculation/v1/calculate/green-grp/print-total-weight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(greenGrpPrintTotalWeightRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceGreenGRPApi - functional programming interface
 */
export const CalculationServiceGreenGRPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceGreenGRPApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpAddressableTelevisionRequest} greenGrpAddressableTelevisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpAddressableTelevision(greenGrpAddressableTelevisionRequest: GreenGrpAddressableTelevisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpAddressableTelevision(greenGrpAddressableTelevisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpAddressableTelevision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpCinemaRequest} greenGrpCinemaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpCinema(greenGrpCinemaRequest: GreenGrpCinemaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpCinema(greenGrpCinemaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpCinema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate digital out of home CO2 emissions using gross contacts
         * @param {GreenGrpDoohGrossContactsRequest} greenGrpDoohGrossContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpDoohGrossContacts(greenGrpDoohGrossContactsRequest: GreenGrpDoohGrossContactsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpDoohGrossContacts(greenGrpDoohGrossContactsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpDoohGrossContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate digital out of home CO2 emissions using number of screens
         * @param {GreenGrpDoohScreensRequest} greenGrpDoohScreensRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpDoohScreens(greenGrpDoohScreensRequest: GreenGrpDoohScreensRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpDoohScreens(greenGrpDoohScreensRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpDoohScreens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpLinearTelevisionRequest} greenGrpLinearTelevisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpLinearTelevision(greenGrpLinearTelevisionRequest: GreenGrpLinearTelevisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpLinearTelevision(greenGrpLinearTelevisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpLinearTelevision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpNewspaperRequest} greenGrpNewspaperRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpNewspaper(greenGrpNewspaperRequest: GreenGrpNewspaperRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpNewspaper(greenGrpNewspaperRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpNewspaper']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate out of home CO2 emissions
         * @param {GreenGrpOOHRequest} greenGrpOOHRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpOOH(greenGrpOOHRequest: GreenGrpOOHRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpOOH(greenGrpOOHRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpOOH']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineAudioRequest} greenGrpOnlineAudioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpOnlineAudio(greenGrpOnlineAudioRequest: GreenGrpOnlineAudioRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpOnlineAudio(greenGrpOnlineAudioRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpOnlineAudio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineImageRequest} greenGrpOnlineImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpOnlineImage(greenGrpOnlineImageRequest: GreenGrpOnlineImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpOnlineImage(greenGrpOnlineImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpOnlineImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineSearchRequest} greenGrpOnlineSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpOnlineSearch(greenGrpOnlineSearchRequest: GreenGrpOnlineSearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpOnlineSearch(greenGrpOnlineSearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpOnlineSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpOnlineVideoRequest} greenGrpOnlineVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpOnlineVideo(greenGrpOnlineVideoRequest: GreenGrpOnlineVideoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpOnlineVideo(greenGrpOnlineVideoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpOnlineVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpRadioRequest} greenGrpRadioRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpRadio(greenGrpRadioRequest: GreenGrpRadioRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpRadio(greenGrpRadioRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpRadio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpSocialMediaOnlineImageRequest} greenGrpSocialMediaOnlineImageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpSocialMediaOnlineImage(greenGrpSocialMediaOnlineImageRequest: GreenGrpSocialMediaOnlineImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpSocialMediaOnlineImage(greenGrpSocialMediaOnlineImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpSocialMediaOnlineImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpSocialMediaOnlineVideoRequest} greenGrpSocialMediaOnlineVideoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpSocialMediaOnlineVideo(greenGrpSocialMediaOnlineVideoRequest: GreenGrpSocialMediaOnlineVideoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpSocialMediaOnlineVideo(greenGrpSocialMediaOnlineVideoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpSocialMediaOnlineVideo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpSupplementRequest} greenGrpSupplementRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpSupplement(greenGrpSupplementRequest: GreenGrpSupplementRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpSupplement(greenGrpSupplementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpSupplement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {GreenGrpPrintTotalWeightRequest} greenGrpPrintTotalWeightRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async greenGrpTotalWeight(greenGrpPrintTotalWeightRequest: GreenGrpPrintTotalWeightRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.greenGrpTotalWeight(greenGrpPrintTotalWeightRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceGreenGRPApi.greenGrpTotalWeight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceGreenGRPApi - factory interface
 */
export const CalculationServiceGreenGRPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceGreenGRPApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpAddressableTelevisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpAddressableTelevision(requestParameters: CalculationServiceGreenGRPApiGreenGrpAddressableTelevisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpAddressableTelevision(requestParameters.greenGrpAddressableTelevisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpCinemaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpCinema(requestParameters: CalculationServiceGreenGRPApiGreenGrpCinemaRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpCinema(requestParameters.greenGrpCinemaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate digital out of home CO2 emissions using gross contacts
         * @param {CalculationServiceGreenGRPApiGreenGrpDoohGrossContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpDoohGrossContacts(requestParameters: CalculationServiceGreenGRPApiGreenGrpDoohGrossContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpDoohGrossContacts(requestParameters.greenGrpDoohGrossContactsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate digital out of home CO2 emissions using number of screens
         * @param {CalculationServiceGreenGRPApiGreenGrpDoohScreensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpDoohScreens(requestParameters: CalculationServiceGreenGRPApiGreenGrpDoohScreensRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpDoohScreens(requestParameters.greenGrpDoohScreensRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpLinearTelevisionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpLinearTelevision(requestParameters: CalculationServiceGreenGRPApiGreenGrpLinearTelevisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpLinearTelevision(requestParameters.greenGrpLinearTelevisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpNewspaperRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpNewspaper(requestParameters: CalculationServiceGreenGRPApiGreenGrpNewspaperRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpNewspaper(requestParameters.greenGrpNewspaperRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate out of home CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpOOHRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOOH(requestParameters: CalculationServiceGreenGRPApiGreenGrpOOHRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpOOH(requestParameters.greenGrpOOHRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpOnlineAudioRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineAudio(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineAudioRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpOnlineAudio(requestParameters.greenGrpOnlineAudioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpOnlineImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineImage(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpOnlineImage(requestParameters.greenGrpOnlineImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpOnlineSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineSearch(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpOnlineSearch(requestParameters.greenGrpOnlineSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpOnlineVideoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpOnlineVideo(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineVideoRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpOnlineVideo(requestParameters.greenGrpOnlineVideoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpRadioRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpRadio(requestParameters: CalculationServiceGreenGRPApiGreenGrpRadioRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpRadio(requestParameters.greenGrpRadioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpSocialMediaOnlineImage(requestParameters: CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpSocialMediaOnlineImage(requestParameters.greenGrpSocialMediaOnlineImageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineVideoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpSocialMediaOnlineVideo(requestParameters: CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineVideoRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpSocialMediaOnlineVideo(requestParameters.greenGrpSocialMediaOnlineVideoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpSupplementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpSupplement(requestParameters: CalculationServiceGreenGRPApiGreenGrpSupplementRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpSupplement(requestParameters.greenGrpSupplementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions
         * @param {CalculationServiceGreenGRPApiGreenGrpTotalWeightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        greenGrpTotalWeight(requestParameters: CalculationServiceGreenGRPApiGreenGrpTotalWeightRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.greenGrpTotalWeight(requestParameters.greenGrpPrintTotalWeightRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for greenGrpAddressableTelevision operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpAddressableTelevisionRequest {
    readonly greenGrpAddressableTelevisionRequest: GreenGrpAddressableTelevisionRequest
}

/**
 * Request parameters for greenGrpCinema operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpCinemaRequest {
    readonly greenGrpCinemaRequest: GreenGrpCinemaRequest
}

/**
 * Request parameters for greenGrpDoohGrossContacts operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpDoohGrossContactsRequest {
    readonly greenGrpDoohGrossContactsRequest: GreenGrpDoohGrossContactsRequest
}

/**
 * Request parameters for greenGrpDoohScreens operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpDoohScreensRequest {
    readonly greenGrpDoohScreensRequest: GreenGrpDoohScreensRequest
}

/**
 * Request parameters for greenGrpLinearTelevision operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpLinearTelevisionRequest {
    readonly greenGrpLinearTelevisionRequest: GreenGrpLinearTelevisionRequest
}

/**
 * Request parameters for greenGrpNewspaper operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpNewspaperRequest {
    readonly greenGrpNewspaperRequest: GreenGrpNewspaperRequest
}

/**
 * Request parameters for greenGrpOOH operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpOOHRequest {
    readonly greenGrpOOHRequest: GreenGrpOOHRequest
}

/**
 * Request parameters for greenGrpOnlineAudio operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpOnlineAudioRequest {
    readonly greenGrpOnlineAudioRequest: GreenGrpOnlineAudioRequest
}

/**
 * Request parameters for greenGrpOnlineImage operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpOnlineImageRequest {
    readonly greenGrpOnlineImageRequest: GreenGrpOnlineImageRequest
}

/**
 * Request parameters for greenGrpOnlineSearch operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpOnlineSearchRequest {
    readonly greenGrpOnlineSearchRequest: GreenGrpOnlineSearchRequest
}

/**
 * Request parameters for greenGrpOnlineVideo operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpOnlineVideoRequest {
    readonly greenGrpOnlineVideoRequest: GreenGrpOnlineVideoRequest
}

/**
 * Request parameters for greenGrpRadio operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpRadioRequest {
    readonly greenGrpRadioRequest: GreenGrpRadioRequest
}

/**
 * Request parameters for greenGrpSocialMediaOnlineImage operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineImageRequest {
    readonly greenGrpSocialMediaOnlineImageRequest: GreenGrpSocialMediaOnlineImageRequest
}

/**
 * Request parameters for greenGrpSocialMediaOnlineVideo operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineVideoRequest {
    readonly greenGrpSocialMediaOnlineVideoRequest: GreenGrpSocialMediaOnlineVideoRequest
}

/**
 * Request parameters for greenGrpSupplement operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpSupplementRequest {
    readonly greenGrpSupplementRequest: GreenGrpSupplementRequest
}

/**
 * Request parameters for greenGrpTotalWeight operation in CalculationServiceGreenGRPApi.
 */
export interface CalculationServiceGreenGRPApiGreenGrpTotalWeightRequest {
    readonly greenGrpPrintTotalWeightRequest: GreenGrpPrintTotalWeightRequest
}

/**
 * CalculationServiceGreenGRPApi - object-oriented interface
 */
export class CalculationServiceGreenGRPApi extends BaseAPI {
    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpAddressableTelevisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpAddressableTelevision(requestParameters: CalculationServiceGreenGRPApiGreenGrpAddressableTelevisionRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpAddressableTelevision(requestParameters.greenGrpAddressableTelevisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpCinemaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpCinema(requestParameters: CalculationServiceGreenGRPApiGreenGrpCinemaRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpCinema(requestParameters.greenGrpCinemaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate digital out of home CO2 emissions using gross contacts
     * @param {CalculationServiceGreenGRPApiGreenGrpDoohGrossContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpDoohGrossContacts(requestParameters: CalculationServiceGreenGRPApiGreenGrpDoohGrossContactsRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpDoohGrossContacts(requestParameters.greenGrpDoohGrossContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate digital out of home CO2 emissions using number of screens
     * @param {CalculationServiceGreenGRPApiGreenGrpDoohScreensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpDoohScreens(requestParameters: CalculationServiceGreenGRPApiGreenGrpDoohScreensRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpDoohScreens(requestParameters.greenGrpDoohScreensRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpLinearTelevisionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpLinearTelevision(requestParameters: CalculationServiceGreenGRPApiGreenGrpLinearTelevisionRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpLinearTelevision(requestParameters.greenGrpLinearTelevisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpNewspaperRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpNewspaper(requestParameters: CalculationServiceGreenGRPApiGreenGrpNewspaperRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpNewspaper(requestParameters.greenGrpNewspaperRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate out of home CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpOOHRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpOOH(requestParameters: CalculationServiceGreenGRPApiGreenGrpOOHRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpOOH(requestParameters.greenGrpOOHRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpOnlineAudioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpOnlineAudio(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineAudioRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpOnlineAudio(requestParameters.greenGrpOnlineAudioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpOnlineImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpOnlineImage(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineImageRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpOnlineImage(requestParameters.greenGrpOnlineImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpOnlineSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpOnlineSearch(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineSearchRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpOnlineSearch(requestParameters.greenGrpOnlineSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpOnlineVideoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpOnlineVideo(requestParameters: CalculationServiceGreenGRPApiGreenGrpOnlineVideoRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpOnlineVideo(requestParameters.greenGrpOnlineVideoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpRadioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpRadio(requestParameters: CalculationServiceGreenGRPApiGreenGrpRadioRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpRadio(requestParameters.greenGrpRadioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpSocialMediaOnlineImage(requestParameters: CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineImageRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpSocialMediaOnlineImage(requestParameters.greenGrpSocialMediaOnlineImageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineVideoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpSocialMediaOnlineVideo(requestParameters: CalculationServiceGreenGRPApiGreenGrpSocialMediaOnlineVideoRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpSocialMediaOnlineVideo(requestParameters.greenGrpSocialMediaOnlineVideoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpSupplementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpSupplement(requestParameters: CalculationServiceGreenGRPApiGreenGrpSupplementRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpSupplement(requestParameters.greenGrpSupplementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions
     * @param {CalculationServiceGreenGRPApiGreenGrpTotalWeightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public greenGrpTotalWeight(requestParameters: CalculationServiceGreenGRPApiGreenGrpTotalWeightRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceGreenGRPApiFp(this.configuration).greenGrpTotalWeight(requestParameters.greenGrpPrintTotalWeightRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

